import { render, staticRenderFns } from "./training-category.vue?vue&type=template&id=c97e22d0&"
import script from "./training-category.vue?vue&type=script&lang=js&"
export * from "./training-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports